import { render } from "./goodsList.vue?vue&type=template&id=41103a0e&scoped=true"
import script from "./goodsList.vue?vue&type=script&lang=js"
export * from "./goodsList.vue?vue&type=script&lang=js"

import "./goodsList.vue?vue&type=style&index=0&id=41103a0e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-41103a0e"

export default script